// extracted by mini-css-extract-plugin
export default {"mainMenu":"MainMenu_mainMenu__vUClK"};